import { connect } from 'react-redux';
import Actions from '../../actions';
import addFundsKWallet from '../../components/pages/add-funds-k-wallet';

const mapStateToProps = (state, ownProps) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

const AddFundsKWalletConnector = connect(mapStateToProps, mapDispatchToProps)(addFundsKWallet);

export default AddFundsKWalletConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/k-wallet/add-funds-k-wallet-connector.js
 **/